import React from "react";

import { Text } from "components";

const InfoRibbon = (props) => {
  return (
    <>
      <div style={{background: '#282828'}} className={props.className}>
        <Text
          className="ml-[11px] text-sm text-white-A700_dd tracking-[0.10px]"
          size="txtInterMedium14"
        >
          {props?.subtitletext}
        </Text>
        <Text
          className="mr-2.5 text-sm text-white-A700_dd tracking-[0.10px]"
          size="txtInterMedium14"
        >
          {props?.mobilenumber}
        </Text>
      </div>
    </>
  );
};

InfoRibbon.defaultProps = {
  subtitletext: "Reasons to shop with us",
  mobilenumber: "+255766777666",
  className: 'bg-deep_purple-900 flex flex-row md:gap-10 items-center justify-between p-3 w-full'
};

export default InfoRibbon;
